import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    type: { default: 'default' },
    size: { default: 'normal' },
    first: { type: Boolean, default: false },
    last: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleClick = () => {
  if (props.disabled) return
  emit('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", {
      'disabled': _ctx.disabled,
      'checked': !_ctx.disabled && _ctx.checked,
      'default': !_ctx.disabled && _ctx.type === 'default',
      'primary': !_ctx.disabled && _ctx.type === 'primary',
      'checkbox': !_ctx.disabled && _ctx.type === 'checkbox',
      'radio': !_ctx.disabled && _ctx.type === 'radio',
      'small': _ctx.size === 'small',
      'first': _ctx.first,
      'last': _ctx.last,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick()))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})